import React from "react";
import SplitHero from "./SplitHero";

const HomeHero: React.FC = () => <SplitHero />;

export default HomeHero;
